import { useMutation, useQueryClient } from 'react-query';
import { ApiClient } from '../../clients';
import { useConfig } from '../config';
import { CreateAgencyProps } from '../../clients/types';

export function useCreateAgency() {
  const config = useConfig();
  const apiClient = new ApiClient(config);
  const queryClient = useQueryClient();

  const { mutate, isLoading, isError, error } = useMutation(
    async (agencyData: CreateAgencyProps) => {
      return await apiClient.createAgency(agencyData);
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['agencies']);
      },
    }
  );

  return {
    createAgency: mutate,
    isCreatingAgency: isLoading,
    isCreateAgencyError: isError,
    createAgencyError: error,
  };
}
